import {useMemo} from 'react';
import {CartItem} from 'src/types/TransactionDetail';
import {toNum} from '../utils/promo';

export enum DiscountType {
  OnScreen = 'On-Screen',
}

type Discount = CartItem['Discounts'] extends (infer P)[] ? P : never;

const isNutrition = (d: Discount) =>
  typeof d.discountType === 'string' &&
  d.discountType.toLowerCase().includes('nutrition');

const isAfterTax = (d: Discount) =>
  typeof d.discountType === 'string' &&
  d.discountType.toLowerCase().includes('after-tax');

const isTender = (d: Discount) =>
  typeof d.discountType === 'string' &&
  d.discountType.toLowerCase().includes('tender');

const isBundle = (d: Discount) =>
  typeof d.discountType === 'string' &&
  d.discountType.toLowerCase().includes('bundle');

const stackOnScreenPromotion = (discounts: Discount[]): Discount => {
  discounts.sort((a, b) =>
    a.displayName.toLowerCase().localeCompare(b.displayName.toLowerCase()),
  );
  return {
    displayName: discounts.map((d) => d.displayName).join(', '),
    discount: discounts.reduce(function (value, discountItem) {
      return value + discountItem.discount;
    }, 0),
    discountHeaderId: discounts.map((d) => d.discountHeaderId).join(','),
    discountType: DiscountType.OnScreen,
    isStackedDiscount: true,
  };
};

export const useDiscounts = (discounts?: CartItem['Discounts']) =>
  useMemo(() => {
    let list = Array.isArray(discounts) ? (discounts as Discount[]) : [];
    const onScreenPromotions = list.filter(
      (d) => d?.discountType === DiscountType.OnScreen,
    );
    if (onScreenPromotions.length > 1) {
      list = [
        stackOnScreenPromotion(onScreenPromotions),
        ...list.filter((d) => d?.discountType !== DiscountType.OnScreen),
      ];
    }
    return {
      //TODO:SM: need to change the logic of applying discounts on the backend. It is currently done incorrectly at item level.
      onscreen: list.filter(
        (d) =>
          !isNutrition(d) &&
          !isTender(d) &&
          !isAfterTax(d) &&
          !isBundle(d) &&
          (toNum(d.discount) ?? 0) > 0,
      ),
      nutrition: list.filter(isNutrition),
    };
  }, [discounts]);
